import { useCallback } from "react";

import { useHistoryTrackerDistanceCalculator } from "../../../history";
import { type UserTriggeredModalsHistoryStateElement, userTriggeredModalStackHistoryKey } from "./use-modal-history-states";

export const useModalHistoryStepCounter = () => {
  const distanceCalculator = useHistoryTrackerDistanceCalculator<UserTriggeredModalsHistoryStateElement[]>(
    userTriggeredModalStackHistoryKey,
    [],
  );

  return useCallback(
    (expectedModalIds: string[]) =>
      distanceCalculator((stepModals) => {
        const modalIds = stepModals.map(({ id }) => id);
        if (modalIds.length !== expectedModalIds.length) {
          return false;
        }

        return modalIds.every((id, i) => id === expectedModalIds[i]);
      }),
    [distanceCalculator],
  );
};
